import { render, staticRenderFns } from "./Knockdowns.vue?vue&type=template&id=9658ec9a"
import script from "./Knockdowns.vue?vue&type=script&lang=js"
export * from "./Knockdowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports